import { Link } from 'react-router-dom';
import { hotCategories } from '@/mocks/animeData';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-6 md:mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
            热门<span className="text-primary-500">分类</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {hotCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-lg text-foreground-600 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}